export default __webpack_public_path__ + "static/media/habib-dadkhah-REBIdR3c2DE-unsplash.52de99d2.png";